export const FAQ_BANK = [
  [
    {
      backgroundImage: "assets/services/img-4.jpg",
      question: "Is AIC recognized?",
      answer:
        "AIC is an ISO certified academy and recognized  to ICAI Calicut chapter.",
    },
    {
      backgroundImage: "assets/services/img-4.jpg",
      question: "Do AIC provide career placement support?",
      answer: "Its a big YES!!! We provide 100% placement for our students.",
    },
    {
      backgroundImage: "assets/services/img-4.jpg",
      question: "What are the certifications offered by AIC?",
      answer:
        "We are offering Certificates provided by NSDC, GST Council, Tally, ICAI, etc for our different courses.",
    },
  ],
  [
    {
      backgroundImage: "assets/services/img-4.jpg",
      question: "What would be average head number of a class in AIC",
      answer: "AIC caters class size not more than 25 students at a time.",
    },
    {
      backgroundImage: "assets/services/img-4.jpg",
      question: "How can I enroll for a course with AIC?",
      answer:
        "You can register for a course by visiting our website and selecting the course you are interested in. Follow the instructions to complete your registration.",
    },
    {
      backgroundImage: "assets/services/img-4.jpg",
      question: "What is the format of the courses in AIC?",
      answer:
        "Our courses are offered in a variety of formats, including online, in-person, and hybrid. This allows our students to choose the format that best fits their needs and schedule.",
    },
  ],
];
export const FAQ_TITLE = "Frequently Asked ?";
